module.exports = __webpack_public_path__ + "static/img/icon3.efdd9c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/icon3.png
// module id = HvIv
// module chunks = 1